<div class="signing-card">
  <gc-text [variant]="'paragraphHeading'">{{
    'signingCard.title' | translate
  }}</gc-text>
  @if (contact()?.contact?.trim(); as contactName) {
    <gc-text
      class="signing-performed-by"
      [variant]="'paragraph'"
      [textColor]="'info'"
    >
      {{ 'buildingPageModal.signing.performedBy' | translate }}
      {{ contactName }}
    </gc-text>
  }
  @if (contact(); as deliveryContact) {
    <div class="contact">
      <gc-text [variant]="'paragraphBold'">{{
        'buildingPageModal.signing.deliveryContact' | translate
      }}</gc-text>
      <gc-text [variant]="'paragraph'">{{ deliveryContact.contact }}</gc-text>
      <gc-text [variant]="'paragraph'">{{
        deliveryContact.phoneNumber
      }}</gc-text>
      <gc-text [variant]="'paragraph'">{{ deliveryContact.email }}</gc-text>
    </div>
  }
  @if (!isReadyForSigning()) {
    <gc-text [variant]="'information'" [textColor]="'info'">{{
      'signingCard.information' | translate
    }}</gc-text>
  }
  <div class="signing-action">
    <gc-button
      [variant]="signing()?.isSigned ? 'secondary' : 'primary'"
      [disabled]="!isReadyForSigning()"
      [size]="isMobileScreen() ? 'full' : 'default'"
      (clicked)="startSigning.emit()"
    >
      {{
        signing()?.isSigned
          ? ('signingCard.newSigning' | translate)
          : ('signingCard.startSigning' | translate)
      }}
    </gc-button>
  </div>

  @if (signing()?.fileHistory?.length) {
    <hr />
    <div class="signing-history">
      @for (
        signedAgreement of signing()!.fileHistory;
        track signedAgreement.fileId
      ) {
        <gc-button
          [variant]="'utility'"
          [size]="'small'"
          [icon]="'file'"
          (clicked)="
            handleDownloadPdf(signedAgreement.fileId, signedAgreement.fileName)
          "
        >
          {{
            isMobileScreen()
              ? signedAgreement.fileName.substring(0, 25) + '...'
              : signedAgreement.fileName
          }}
        </gc-button>
      }
    </div>
  }
</div>
